import { useEffect, useState } from "react";
import '../../assets/css/PlayerList.css';
import { useNavigate } from "react-router-dom";
import boyImage from '../../assets/images/boy.png';
import girlImage from '../../assets/images/girl.png';


const PlayerList = ({ stringerPlayer = [] ,disableButton }) => {
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState("");
    const [disabledButton ,setDisabledButton] = useState('');
    const onPlayerList = (id) => {
        navigate('/playerprofile', { state: { stringerPlayers: stringerPlayers, id: id ,disabledButton:disabledButton } });
    };
    const [stringerPlayers, setStringerPlayers] = useState();
    const filteredPlayers = stringerPlayer.length > 0 && stringerPlayer?.filter(player => player?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()));
    useEffect(() => {
        setStringerPlayers(stringerPlayer)
    },[])
    useEffect(()=>{
        setDisabledButton(disableButton)
    },[disableButton])


    return (
        <div>
            <div className="row players-list-container">
                {filteredPlayers?.length > 0 && (
                    filteredPlayers?.map((player, index) => (
                        <div key={player.id}
                            className={`col-lg-4 ${(filteredPlayers?.length - 1) > index ? '' : ''} col-sm-4 col-md-4 player-list-container`}
                            onClick={() => onPlayerList(player.id)}>
                            <div className="player-container d-flex p-2  me-sm-3" style={{ boxShadow: '0px 2px 4px 0px #60617029' }} >
                                <div className="d-flex">
                                    <div>
                                        <img src={player?.avatarUrl || (player?.gender == 'MALE' ? boyImage : girlImage)} alt={player?.name} width='100px' />
                                        <div style={{ color: '#1F2024', fontWeight: 400, fontSize: '12px',textAlign:"center" }}>
                                            {player?.avatarName}
                                        </div>
                                    </div>
                                    <div style={{ height: '118px', marginLeft: '10px', width: '15px', backgroundColor: '#e9ecef', borderRadius: '0px', overflow: 'hidden' }}>
                                        <div
                                            style={{
                                                height: `${player?.reliability}%`,
                                                width: '100%',
                                                backgroundColor: 'green',
                                                transition: 'height 0.3s ease',
                                            }}
                                        ></div>
                                    </div>
                                </div>
                                <div className="ps-3 pt-3">
                                    <div style={{ fontWeight: 400, fontSize: '12px', lineHeight: '11px', color: '#71727A' }}>
                                          <span style={{ color: '#1F2024', fontWeight: 700, fontSize: '15px',textAlign:"center" }}>
                                            {player?.name}
                                        </span>
                                        {" "}
                                        <span className="pt-1" style={{ fontSize: '11px', display: 'inline-block', marginTop: '2px' }}>{ player?.gender ? `(${player?.gender})` :''}</span>
                                    </div>
                                    <span className="pt-1" style={{ fontSize: '13px', display: 'inline-block', marginTop: '2px' }}>{player?.sportProfiles[0]?.sport}</span>{' '}
                                      <span className="pt-1" style={{ fontSize: '10px', display: 'inline-block', marginTop: '2px',color: '#71727A' }}>{ player?.sportProfiles[0]?.skillLevel ? `(${player?.sportProfiles[0]?.skillLevel})` : ''}</span>
                                    <div className="distance-text pt-2">
                                        {`${(player.distance / 1609.34).toFixed(2)} miles away`}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                )
                }


            </div>
        </div>
    );
};

export default PlayerList;
